import { Icon } from "./Icon.tsx";

/** "Multiple selection" mode toggle — two overlapping marquee-selection boxes, each with a picked-element dot, standing in for "clicks now add to the selection instead of replacing it". */
export function MultiSelectIcon() {
  return (
    <Icon>
      <rect x="3" y="3" width="12" height="12" rx="1.5" strokeDasharray="3 2.5" />
      <rect x="9" y="9" width="12" height="12" rx="1.5" strokeDasharray="3 2.5" />
      <circle cx="9" cy="9" r="1.6" fill="currentColor" stroke="none" />
      <circle cx="15" cy="15" r="1.6" fill="currentColor" stroke="none" />
    </Icon>
  );
}
